export const getRowState = (rowId, { selectedRowIds, expandedRowIds, disabledRowIds, }) => {
    const rowState = {
        selected: (selectedRowIds === null || selectedRowIds === void 0 ? void 0 : selectedRowIds.includes(rowId)) || false,
        expanded: (expandedRowIds === null || expandedRowIds === void 0 ? void 0 : expandedRowIds.includes(rowId)) || false,
        disabled: (disabledRowIds === null || disabledRowIds === void 0 ? void 0 : disabledRowIds.includes(rowId)) || false,
    };
    return rowState;
};
//# sourceMappingURL=getRowState.js.map